import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

/** Works only when useMocks flag is enabled in the environment or when is not production mode
 * This interceptor maps requests and params into json files otherwise passes unchanged requests.
 */
@Injectable()
export class MockInterceptor implements HttpInterceptor {
  private readonly mocks = '/dslocate2/assets/mocks';

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (environment.envName !== 'localhost') {
      return next.handle(req);
    }
    const mockedReq = this.urlMatcherForMocks(req);
    return next.handle(mockedReq);
  }

  private urlMatcherForMocks(req: HttpRequest<any>): HttpRequest<any> {
    let cloned: HttpRequest<any>;
    switch (true) {
      // case req.url.includes('alarm_api/alarms'):
      //   cloned = this.prepareMockResponse(req, 'alarms');
      //   break;
      // case req.url.includes('alarm_api/contacts'):
      //   cloned = this.prepareMockResponse(req, 'contacts');
      //   break;
      // case req.url.includes('archive'):
      //   cloned = this.prepareMockResponse(req, 'archive-3months');
      //   break;
      case req.url.includes('archive'):
        cloned = this.prepareMockResponse(req, 'archive-etoll');
        break;
      // case req.url.includes('vehicle-messages'):
      //   cloned = this.prepareMockResponse(req, 'vehicle-notifications');
      //   break;
      // case req.url.includes('messages'):
      //   cloned = this.prepareMockResponse(req, 'notifications');
      //   break;
      case req.url.includes('tacho'):
        cloned = this.prepareMockResponse(req, 'tacho');
        break;
      /*      case req.url.includes('login'):
        cloned = this.prepareMockResponse(
          req,
          'initial-vehicles-positions',
          'xml'
        );
        break;*/

      /*      case req.url.includes('demand/position'):
        cloned = this.prepareMockResponse(
          req,
          'update-vehicles-positions',
          'xml'
        );
        break;*/

      // case req.url.includes('reports/210'):
      //     cloned = this.prepareMockResponse(req, 'tutorial-report-real-data-all-vehicles', 'json');
      //     break;
      // case req.url.includes('reports/233'):
      //   cloned = this.prepareMockResponse(
      //     req,
      //     'digital-temperature-report',
      //     'json'
      //   );
      //   break;

      // case req.url.includes('reports/210'):
      //     cloned = this.prepareMockResponse(req, 'tutorial-report-real-data-all-vehicles', 'json');
      //     break;

      // case req.url.includes('reports/232'):
      //   cloned = this.prepareMockResponse(req, 'poi-report', 'json');
      //   break;

      // case req.url.includes('reports/211'):
      //     cloned = this.prepareMockResponse(req, 'ranking-of-forklifts', 'json');
      //     break;

      // case req.url.includes('reports/212'):
      //     cloned = this.prepareMockResponse(req, 'ranking-of-operators', 'json');
      //     break;

      // case req.url.includes('reports/213'):
      //     cloned = this.prepareMockResponse(req, 'hit-report-forklift-real-data', 'json');
      //     break;

      // case req.url.includes('reports/218'):
      //     cloned = this.prepareMockResponse(req, 'hit-report-operator', 'json');
      //     break;

      // case req.url.includes('reports/214'):
      //     cloned = this.prepareMockResponse(req, 'work-of-drivers-report', 'json');
      //     break;

      // case req.url.includes('reports/215'):
      //     cloned = this.prepareMockResponse(req, 'work-of-forklifts-report', 'json');
      //     break;

      // case req.url.includes('reports/216'):
      //     cloned = this.prepareMockResponse(req, 'fleet-of-forklifts-report', 'json');
      //     break;

      // case req.url.includes('reports/217'):
      //     cloned = this.prepareMockResponse(req, 'battery-report', 'json');
      //     break;

      // case req.url.includes('reports/220'):
      //     cloned = this.prepareMockResponse(req, 'virtual-policeman-report', 'json');
      //     break;
      // case req.url.includes('reports/222'):
      // cloned = this.prepareMockResponse(req, 'private-business-rides-report', 'json');
      // break;
      // case req.url.includes('reports/223'):
      // cloned = this.prepareMockResponse(req, 'traffic-offenders-report', 'json');
      // break;
      // case req.url.includes('reports/231'):
      //   cloned = this.prepareMockResponse(req, 'door-opening-report', 'json');
      //   break;
      // case req.url.includes('reports/230'):
      //   cloned = this.prepareMockResponse(req, 'baktir-report', 'json');
      //   break;
      // case req.url.includes('reports/235'):
      //   cloned = this.prepareMockResponse(req, 'onoff-report', 'json');
      //   break;
      // case req.url.includes('reports/239'):
      //   cloned = this.prepareMockResponse(req, 'engine-speed-report', 'json');
      //   break;
      // default:
      default:
        cloned = req.clone();
        break;
    }
    return cloned;
  }

  private prepareMockResponse(
    req: HttpRequest<any>,
    mockPath: string,
    fileType = 'json'
  ): HttpRequest<any> {
    console.warn('Application is using mock data for this call: ', req.url);
    return req.clone({
      url: `${this.mocks}/${mockPath}.${fileType}`,
      method: 'GET',
    });
  }
}
